// extracted by mini-css-extract-plugin
export default {"container":"ValidationItem_container__h-V4Y","valid":"ValidationItem_valid__WPtjf"};